import { SipPlanMode } from '../api/types'
import { SipYourPlanBody } from './body/yourPlan/SipYourPlanBody'
import { YourPlanPlansListErrorState } from './body/yourPlan/YourPlanPlansListErrorState'
import { SipPlansFooter } from './footer/SipPlansFooter'
import { PlansListChrome } from '../../lumpsum/plans-list/header/common/PlansListChrome'
import { SipPlansActionFilters } from './header/common/SipPlansActionFilters'
import {
  resolveSipYourPlanHeaderAppearance,
  SipYourPlanHeader
} from './header/yourPlan/SipYourPlanHeader'
import {
  isSipPlansFetchFailed,
  isSipPlansLoading,
  useSipPlansContext
} from './SipPlansProvider'
import { PlansCategoryListSkeleton } from '../../lumpsum/plans-list/lumpsum-ui-components/PlansCategoryListSkeleton'
import { isSipPlanRolledOut } from './timer/shared/planStatus'
import { SipYourPlanTimerPanel } from './timer/yourPlan/SipYourPlanTimerPanel'

/** Your Plan tab: timer/strategy shell vs normal plan slots. */
export function SipYourPlanPageContent() {
  const { plansOverview, plansQuery, markTimerResumeRefetch } = useSipPlansContext()
  const chromeBackground = resolveSipYourPlanHeaderAppearance(
    plansOverview?.riskProfile
  ).chromeBackground

  if (isSipPlansLoading(SipPlanMode.YOUR_PLAN, plansQuery)) {
    return (
      <>
        <PlansListChrome background={chromeBackground}>
          <SipYourPlanHeader />
        </PlansListChrome>
        <PlansCategoryListSkeleton />
      </>
    )
  }

  if (isSipPlansFetchFailed(SipPlanMode.YOUR_PLAN, plansQuery)) {
    return <YourPlanPlansListErrorState onRetry={plansQuery.refetch} />
  }

  if (!isSipPlanRolledOut(plansOverview?.planStatus)) {
    return (
      <SipYourPlanTimerPanel
        planStatus={plansOverview?.planStatus}
        timeToPlanDrop={plansOverview?.timeToPlanDrop}
        isSubscriptionEligible={plansOverview?.isPlanSubscriptionEligible === true}
        strategyCta={plansOverview?.strategyCta}
        refetchPlan={() => {
          markTimerResumeRefetch()
          void plansQuery.refetch()
        }}
      />
    )
  }

  return (
    <>
      <PlansListChrome background={chromeBackground}>
        <SipYourPlanHeader />
        <SipPlansActionFilters />
      </PlansListChrome>
      <SipYourPlanBody />
      <SipPlansFooter />
    </>
  )
}
